export enum SystemParamDataTypes {
  Number = "Number",
  TrueFalse = "TrueFalse",
  Percentage = "Percentage",
  PercentageExtended = "PercentageExtended",
  Currency = "Currency",
  Date = "Date",
  String = "String"
}
